"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedDomainOrPrimaryDomain = exports.getImportExternalBlog = exports.getSlug = exports.getDomain = exports.getName = void 0;

var _reselect = require("reselect");

var _CreateNewBlog = _interopRequireWildcard(require("../../stagedObjects/CreateNewBlog"));

var _selectors = require("settings-ui-sdk/Domains/selectors");

var _constants = require("settings-ui-sdk/Blogs/constants");

var getName = _CreateNewBlog.default.getStagedProperty(_constants.NAME);

exports.getName = getName;

var getDomain = _CreateNewBlog.default.getStagedProperty(_constants.DOMAIN);

exports.getDomain = getDomain;

var getSlug = _CreateNewBlog.default.getStagedProperty(_constants.SLUG);

exports.getSlug = getSlug;

var getImportExternalBlog = _CreateNewBlog.default.getStagedProperty(_CreateNewBlog.IMPORT_EXTERNAL_BLOG);

exports.getImportExternalBlog = getImportExternalBlog;
var getIsAnyDomainSelected = (0, _reselect.createSelector)([getDomain], function (stagedDomain) {
  return Boolean(stagedDomain);
});
var getSelectedDomainOrPrimaryDomain = (0, _reselect.createSelector)([getDomain, _selectors.getPrimaryBlogDomain, getIsAnyDomainSelected], function (stagedDomainName, primaryDomain, isAnyDomainSelected) {
  return isAnyDomainSelected ? stagedDomainName : primaryDomain.get('domain');
});
exports.getSelectedDomainOrPrimaryDomain = getSelectedDomainOrPrimaryDomain;